import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";
import OutreachAdmin from "@/pages/OutreachAdmin";
import Concierge from "@/pages/Concierge";
import Registry from "@/pages/Registry";
import CookieBanner from "@/components/site/CookieBanner";
import ChatWidget from "@/components/site/ChatWidget";
import { Toaster } from "sonner";

function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;
    const key = `vdi_visit_${path}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    axios
      .post(`${window.location.origin}/api/track/visit`, { path })
      .catch(() => {});
  }, [location.pathname]);
  return null;
}

function PublicOverlays() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  if (location.pathname.startsWith("/concierge")) return <CookieBanner />;
  if (location.pathname.startsWith("/allocazioni")) return <CookieBanner />;
  return (
    <>
      <CookieBanner />
      <ChatWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/allocazioni" element={<Registry />} />
          <Route path="/registro" element={<Navigate to="/allocazioni" replace />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/admin/outreach" element={<OutreachAdmin />} />
          <Route path="/concierge/:wineId" element={<Concierge />} />
        </Routes>
        <PublicOverlays />
        <VisitTracker />
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#FDFBF7",
            border: "0",
            borderRadius: "2px",
            fontFamily: "Outfit, sans-serif",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
}

export default App;
